// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay])

let configurationCarousels = document.querySelectorAll('.wp-block-acf-configurations-carousel')

configurationCarousels.forEach(carousel =>{
  let currentGallerySlide = carousel.querySelector(".current-slide");
  let totalGallerySlides = carousel.querySelector(".total-slide");

  // init Swiper:
  let swiper = new Swiper(carousel, {
    loop: true,
    autoplay: {
      delay: 2000,
      pauseOnMouseEnter: false,
      disableOnInteraction: false,
      reverseDirection: false
    },

    // bullets
    pagination: {
      el: '.swiper-pagination'
    },

    // arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    on: {
      init: function (el) {
        currentGallerySlide.innerHTML = el.activeIndex + 1
        totalGallerySlides.innerHTML = el.slides.length
      },
      slideChange: function (el) {
        currentGallerySlide.innerHTML = el.activeIndex + 1
        totalGallerySlides.innerHTML = el.slides.length
      },
    },

  })
})


